export default __webpack_public_path__ + "static/media/image32.d8e91d2d.jpg";